// Small bevelled pill buttons used in the footer (Admin, Sign out) and on the
// event page (RSVP, Share, Delete Event), so they all look the same.

export const toolbarButton = {
  background: 'linear-gradient(180deg, #fff 0%, #f3f3f3 100%)',
  color: '#111',
  border: '1px solid #c9c9c9',
  borderRadius: 2.5,
  padding: '5px 10px',
  fontFamily: "'Reddit Mono', monospace",
  fontSize: '11px',
  cursor: 'pointer',
  boxShadow: '0 1px 2px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.9)',
  transition: 'background 0.15s ease, box-shadow 0.15s ease',
};

// "On" state (e.g. RSVP'd, share panel open): pressed in, peach tint.
export const toolbarButtonActive = {
  background: 'linear-gradient(180deg, #ffe8d5 0%, #fff3ea 100%)',
  border: '1px solid #ff7708',
  color: '#7b4519',
  boxShadow: 'inset 0 1px 3px rgba(134,69,16,0.25)',
};
